<form [formGroup]="signUpStepTwo" id="register-step-2">
  <div  *ngIf="callingFrom === 'regTwo' || fromNavBar===true">
    <h1 class="headingtitle text-left">{{'registrationStepTwo.createAnAccount' | translate}}</h1></div>
  <div  *ngIf="callingFrom === 'modalRegTwo'">
      <h1 class="h-modal--title">{{'registrationStepTwo.toContinueCompleteYourAccount' | translate}}</h1></div>

  <div class="main_register">
    <!-- <div *ngIf="serverError">{{serverError}}</div> -->
    <!-- Dynamic Feilds first name and last name-->
    <ng-container *ngIf="isShowNames">
    <!-- First name -->
    <div class="row no-margin">
      <div class="custom_padding col-sm-12">
        <div class="form-group" [ngClass]="getFormFiledClass('firstName',signUpStepTwo, isSubmitted)">
          <div class="controls">
            <input type="text" formControlName="firstName" name="firstName" id="firstName" class="floatLabel form-control" (focus)="onFocusForElement('firstName')"
          (focusout)="onFocusOutForElement()" />
            <label for="firstName">{{'registrationStepOne.firstName' | translate}}</label>
          </div>
          <div class="arrow_box" *ngIf="shouldShowErrors('firstName',signUpStepTwo) && (signUpStepTwo.controls['firstName'].value || isSubmitted)"> {{getErrorMessage('firstName',signUpStepTwo)}} </div>
        </div>
      </div>
    </div>
    <!-- Last name -->
    <div class="row no-margin">
      <div class="custom_padding col-sm-12">
        <div class="form-group" [ngClass]="getFormFiledClass('lastName',signUpStepTwo, isSubmitted)">
          <div class="controls">
            <input type="text" formControlName="lastName" name="lastName" id="lastName" class="floatLabel form-control" (focus)="onFocusForElement('lastName')"
          (focusout)="onFocusOutForElement()" />
            <label for="lastName">{{'registrationStepOne.lastName' | translate}}</label>
          </div>
          <div class="arrow_box" *ngIf="shouldShowErrors('lastName',signUpStepTwo) && (signUpStepTwo.controls['lastName'].value || isSubmitted)"> {{getErrorMessage('lastName',signUpStepTwo)}} </div>
        </div>
      </div>
    </div>
   </ng-container>
    <!-- address1 -->
    <div class="row no-margin">
      <div class="custom_padding col-sm-12">
        <div class="form-group" [ngClass]="getFormFiledClass('address1',signUpStepTwo, isSubmitted)">
          <div class="controls">
            <input type="text" formControlName="address1" name="address1" id="address1" class="floatLabel form-control" (focus)="onFocusForElement('address1')"
          (focusout)="onFocusOutForElement()" />
            <label for="address1">{{'registrationStepTwo.postalAddress' | translate}}</label>
          </div>
          <div class="arrow_box" *ngIf="shouldShowErrors('address1',signUpStepTwo) && (signUpStepTwo.controls['address1'].value || isSubmitted)"> {{getErrorMessage('address1',signUpStepTwo)}} </div>
        </div>
      </div>
    </div>
    <div class="row no-margin">
      <div class="custom_padding col-sm-7 left_signup-12">
        <!-- city -->
        <div class="form-group" [ngClass]="getFormFiledClass('city',signUpStepTwo, isSubmitted)">
          <div class="controls">
            <input type="text" formControlName="city" name="city" class="floatLabel form-control" id="city" (focus)="onFocusForElement('city')"
              (focusout)="onFocusOutForElement()" />
            <label for="city">{{'registrationStepTwo.city' | translate}}</label>
          </div>
          <div class="arrow_box" *ngIf="shouldShowErrors('city',signUpStepTwo) && (signUpStepTwo.controls['city'].value || isSubmitted)">{{getErrorMessage('city',signUpStepTwo)}}</div>
        </div>
      </div>
      <div class="custom_padding col-sm-5 left_signup-12">
        <!-- zip -->
        <div class="form-group" [ngClass]="getFormFiledClass('zip',signUpStepTwo, isSubmitted)">
          <div class="controls">
            <input type="text" formControlName="zip" name="zip" id="zip" class="floatLabel form-control" (focus)="onFocusForElement('zip')"
              (focusout)="onFocusOutForElement()" />
            <label for="zip">{{'registrationStepTwo.ZIPCode' | translate}}</label>
          </div>
          <div class="arrow_box_small" *ngIf="shouldShowErrors('zip',signUpStepTwo) && (signUpStepTwo.controls['zip'].value || isSubmitted)">{{getErrorMessage('zip',signUpStepTwo)}}</div>
        </div>
      </div>
    </div>
    <!-- country -->
    <div class="row no-margin country-div">
      <div class="custom_padding col-sm-12">
        <div class="form-group" [ngClass]="getFormFiledClass('country',signUpStepTwo, isSubmitted)">
          <div class="controls select-succ">
            <select formControlName="country" [attr.name]="ipCountry == 'SE' ? null : 'country'" [attr.autocomplete]="ipCountry == 'SE' ? 'new-password' : 'on'" id="country" (change)="onCountrySelect()"(focus)="onFocusForElement('country')" (focusout)="onFocusOutForElement()"
              class="floatLabel form-control classic">
              <!-- <option selected="country">Country</option> -->
              <option selected value="" disabled>{{'registrationStepTwo.country' | translate}}</option>
              <!-- {{availableCountry && availableCountry.length}} -->
              <option *ngFor="let country of availableCountry" [ngValue]="country.iso">{{country.name}}</option>
            </select>
          </div>
          <div class="arrow_box " *ngIf="shouldShowErrors('country',signUpStepTwo) && (signUpStepTwo.controls['country'].value || isSubmitted)"> {{getErrorMessage('country',signUpStepTwo)}} </div>
        </div>
      </div>
    </div>
    <!-- State -->
    <div class="row no-margin" *ngIf="isSelectedCountryStateDataAvailable">
      <div class="custom_padding col-sm-12">
        <div class="form-group" [ngClass]="getFormFiledClass('state',signUpStepTwo, isSubmitted)">
          <div class="controls select-succ">
            <select formControlName="state" id="state" (focus)="onFocusForElement('state')" (focusout)="onFocusOutForElement()"
              class="floatLabel form-control classic">
              <!-- <option selected="country">Country</option> -->
              <option value="" disabled>{{'registrationStepTwo.state' | translate}}</option>
              <ng-container *ngFor="let state of availableStates;">
                <option  [ngValue]="state.code">{{state.name}}</option>
              </ng-container>
              
            </select>
          </div>
          <div class="arrow_box " *ngIf="shouldShowErrors('state',signUpStepTwo) && (signUpStepTwo.controls['state'].value || isSubmitted)"> {{getErrorMessage('state',signUpStepTwo)}} </div>
        </div>
      </div>
    </div>

    <div class="row no-margin birthday">
      <!-- <div class="col-sm-3 flex-label custom_padding left_signup-6 birht_label">
        <label>{{'registrationStepTwo.dateOfBirth' | translate}}:</label>
      </div> -->
      <div class="custom_padding col-sm-3 col-xs-4 left_signup-6">
        <!-- date -->
        <div class="controls">
          <div class="form-group" [ngClass]="dobValidationDate ? dobValidationDate : ''">
            <input type="number" (keydown)="restrictZero($event,'date')" (focus)="resetDobValidation()"   min='1' onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"  (keyup)="updateDobValues('date','dateFeild')" (focusout)="updateDateWithDigits('date')" (input)="updateDobValues('date','dateFeild')" formControlName="date"  
            class="form-control classic floatLabel" id='dateFeild'/>
            <label for="date" >{{'registrationStepTwo.dateLabel' | translate}}</label>
            
          </div>
        </div>
      </div>
      <div class="custom_padding col-sm-3 col-xs-4 left_signup-6">
        <!-- month -->
        <div class="controls">
          <div class="name-field form-group" [ngClass]="dobValidationMonth ? dobValidationMonth : ''">
            <input id='monthFeild' min='1' (focus)="resetDobValidation()"  formControlName="month" (keydown)="restrictZero($event,'month')" (keyup)="updateDobValues('month','monthFeild')" (input)="updateDobValues('month','monthFeild')" type="number" class="form-control classic floatLabel" (focusout)="updateDateWithDigits('month')"/>
            <label for="month">{{'registrationStepTwo.monthLabel' | translate}}</label>
          </div>
        </div>
      </div>
      <div class="custom_padding col-sm-3 col-xs-4 left_signup-6 last-child">
        <!-- year -->
        
        <div class="controls">
          <div class="name-field form-group" [ngClass]="dobValidationYear ? dobValidationYear : ''">            
          <input id='yearFeild' min='1' (keydown)="restrictZero($event,'year')" (focus)="resetDobValidation()"  formControlName="year" (keyup)="updateDobValues('year','yearFeild')" (input)="updateDobValues('year','yearFeild')" type="number" class="form-control classic floatLabel" (focusout)="updateDateWithDigits('year')"/>           
          <label for="year">{{'registrationStepTwo.yearLabel' | translate}}</label>
          </div>
        </div>
      </div>
      

      <!-- for Birthday Error Msg  -->
      <ng-container *ngIf="dobValidationMes">
        <div class="arrow_box tt t-r" >{{dobValidationMes }}</div>
      </ng-container> 
     
    </div>
    <div class="row no-margin select-gender-field">
      <div class="custom_padding col-sm-12 ">
        <!-- gender -->
        
          <div class="form-group" [ngClass]="getFormFiledClass('gender',signUpStepTwo, isSubmitted)">
            <div class="controls select-succ">
            <select formControlName="gender" name="gender" (focus)="onFocusForElement('gender')" (focusout)="onFocusOutForElement()"
              class="floatLabel form-control classic">
              <option value="null" disabled="true">{{'registrationStepTwo.gender' | translate}}</option>
              <option value="M">{{'registrationStepTwo.male' | translate}}</option>
              <option value="F">{{'registrationStepTwo.female' | translate}}</option>
            </select>
            <div class="arrow_box" *ngIf="shouldShowErrors('gender',signUpStepTwo)">{{getErrorMessage('gender',signUpStepTwo)}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-btn" *ngIf="!isRealUser" [ngClass]="getButtonDisabled(signUpStepTwo) ? 'disabled' : ''">
    <button type="button" class="submitBtn site-btn site-btn__primary site-btn--lg" id="stepTwoId" (click)="updateUser('stepTwoId')">{{'registrationStepTwo.save' | translate}}</button>
  </div>
</form>
